import { useState } from 'react';

import { ModalBase } from '../../../components/modals/ModalBase';

import type React from 'react';

const REASON_FLOOR = 4;

export interface RejectOverrideModalProps {
  open: boolean;
  typeLabel: string;
  isPending: boolean;
  failed: boolean;
  outcome: string | null;
  onClose: () => void;
  onConfirm: (approvalNote: string) => void;
}

export function RejectOverrideModal({
  open,
  typeLabel,
  isPending,
  failed,
  outcome,
  onClose,
  onConfirm,
}: RejectOverrideModalProps): React.JSX.Element | null {
  const [reason, setReason] = useState('');
  if (!open) return null;

  const trimmedLen = reason.trim().length;
  const canSubmit = trimmedLen >= REASON_FLOOR && !isPending;

  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title="Rejeitar override"
      width={500}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button className="btn-ghost-mini" type="button" onClick={onClose} disabled={isPending}>
            Cancelar
          </button>
          <button
            className="btn-ghost-mini btn-ghost-mini--primary"
            type="button"
            disabled={!canSubmit}
            onClick={() => onConfirm(reason)}
          >
            {isPending ? 'Rejeitando…' : 'Rejeitar'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <p>
          Rejeitar o override <b>{typeLabel}</b>?
        </p>
        <label className="modal-form__field">
          <span className="modal-form__label">
            Motivo da rejeição (obrigatório · mínimo {REASON_FLOOR} caracteres)
          </span>
          <textarea
            className="modal-form__textarea"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder="Conversa muito sensível para esta exceção…"
          />
          <span className="modal-form__hint">
            {trimmedLen}/{REASON_FLOOR} mínimo
          </span>
        </label>
        {failed && (
          <div className="banner banner--danger" role="alert">
            <div className="banner__body">
              <span className="banner__title">Não foi possível rejeitar o override.</span>
            </div>
          </div>
        )}
        {outcome !== null && (
          <div className="modal-form__callout" role="status">
            {outcome}
          </div>
        )}
      </div>
    </ModalBase>
  );
}
